"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/*
  method of detecting print adapted from:
  www.tjvantoll.com/2012/06/15/detecting-print-requests-with-javascript/
*/


exports.default = function (WrappedComponent) {
  return function (_React$Component) {
    _inherits(DetectPrint, _React$Component);

    function DetectPrint() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DetectPrint);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetectPrint.__proto__ || Object.getPrototypeOf(DetectPrint)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        printing: false
      }, _this.list = typeof window !== 'undefined' && window.matchMedia && window.matchMedia("print"), _this.handleEvent = function (list) {
        _this.setState({
          printing: !!list.matches
        });
      }, _this.componentWillMount = function () {
        _this.list && _this.list.addListener(_this.handleEvent);
      }, _this.componentWillUnmount = function () {
        _this.list && _this.list.removeListener(_this.handleEvent);
      }, _this.render = function () {
        return _react2.default.createElement(WrappedComponent, _extends({}, _this.props, {
          printing: _this.state.printing
        }));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return DetectPrint;
  }(_react2.default.Component);
};